import { types, flow, getParent } from "mobx-state-tree"
import { PAYMENT_PROVIDERS } from "~/utilities/constants"
import Network from "~/stores/models/Network"

const threeDSecureStore = types
  .model("threeDSecureStore", {
    initialized: types.optional(types.boolean, false),
    // Should we force 3D Secure for this transaction (currently only BT)
    isRequired: types.optional(types.boolean, false),
    verify3DSAmount: types.maybeNull(types.number),
    verify3DSAmountService: types.optional(Network, {}),
    show3DSModal: types.optional(types.boolean, false),
    responseData: types.frozen({})
  })
  .views(self => ({
    get paymentStore() {
      return getParent(self)
    },
    get paymentProcessor() {
      return self.paymentStore.paymentProcessor
    },
    get paymentProcessorStore() {
      return self.paymentStore[self.paymentProcessor]
    },
    get paymentProcessorThreeDStore() {
      return self.paymentProcessorStore.threeDSecure
    },
    get isLoading() {
      return self.verify3DSAmountService.isLoading || self.paymentProcessorThreeDStore?.isLoading
    }
  }))
  .volatile(() => ({
    get3DSVerifyAmount: async () => {}, // async function to call to get final charge amount
    modalDOMref: null // where 3DS iFrame will be appended or shown.
  }))
  .actions(self => ({
    getVerifyAmount: flow(function* getVerifyAmount() {
      try {
        self.verify3DSAmountService.requestReset()
        self.verify3DSAmountService.requestStart()
        const amount = yield self.get3DSVerifyAmount();
        self.setVerify3DSAmount(amount)
        self.verify3DSAmountService.requestComplete()
      } catch (error) {
        console.error("Error fetching verify amount", error)
        self.verify3DSAmountService.requestError(error)
        throw error
      }
    }),
    verify: flow(function* verifyGen() {
      try {
        // only braintree is supported at the moment
        if (self.paymentProcessor !== PAYMENT_PROVIDERS.braintree) {
          return self.responseData
        }
        self.setModalVisability(true)
        // Build client on users payment provider store.
        yield self.getVerifyAmount()
        const response = yield self.paymentProcessorThreeDStore.verify()
        self.setResponseData(response)
        self.setModalVisability(false)
        return self.responseData
      } catch (error) {
        self.reset()
        console.error("[3DS] Error Verifying", error)
        throw error
      }
    }),
    setResponseData(responseData) {
      self.responseData = responseData
    },
    setGet3DSVerifyAmount(func) {
      self.get3DSVerifyAmount = func
    },
    setVerify3DSAmount(amount) {
      self.verify3DSAmount = amount
    },
    setIsRequired(value) {
      self.isRequired = value
    },
    setInitialized(value) {
      self.initialized = value
    },
    reset() {
      self.setVerify3DSAmount(null)
      self.setInitialized(false)
      self.set3DSModalChildRef(null)
      self.setModalVisability(false)
      if (self.paymentProcessorThreeDStore) {
        self.paymentProcessorThreeDStore.teardown()
      }
    },
    teardown() {
      self.isRequired = false
      self.reset()
    },
    setModalVisability(visable) {
      self.show3DSModal = visable
    },
    set3DSModalChildRef(modalDOMref) {
      self.modalDOMref = modalDOMref
    },
  }))

export default threeDSecureStore
